import React, { useEffect, useState } from 'react';

const RateLimitModal = ({ isVisible, onClose, message }) => {
  const [timeLeft, setTimeLeft] = useState(4);

  useEffect(() => {
    if (!isVisible) {
      setTimeLeft(5); // Reset timer when modal becomes invisible
      return;
    }

    const timer = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          onClose(); // Auto-close when timer reaches 0
          return 5; // Reset for next time
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [isVisible, onClose]);

  if (!isVisible) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.7)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000
    }}>
      <div style={{
        backgroundColor: '#2a2a2a',
        border: '2px solid #ff6b6b',
        borderRadius: '10px',
        padding: '30px',
        maxWidth: '400px',
        width: '90%',
        textAlign: 'center',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.5)'
      }}>
        <div style={{
          fontSize: '24px',
          marginBottom: '15px'
        }}>
          ⚠️
        </div>
        
        <h3 style={{
          color: '#ff6b6b',
          marginBottom: '15px',
          fontSize: '18px',
          fontWeight: 'bold'
        }}>
          Limit Exceeded
        </h3>
        
        <p style={{
          color: '#fff',
          marginBottom: '20px',
          lineHeight: '1.4',
          fontSize: '14px'
        }}>
          Please wait and try again.
        </p>
     
          <button
            onClick={onClose}
            style={{
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              padding: '10px 20px',
              fontSize: '14px',
              fontWeight: 'bold',
              cursor: 'pointer',
              backgroundColor: 'transparent',
            }}
            // onMouseEnter={(e) => e.target.style.backgroundColor = '#4a9538'}
            // onMouseLeave={(e) => e.target.style.backgroundColor = '#58b047'}
          >
            Dismiss ({timeLeft})
          </button>
      </div>
    </div>
  );
};

export default RateLimitModal; 